import { Translate } from 'react-admin'
import { ProductType } from '../types/ProductType'

export const ProductsHelper = {
  formatProductTypes: (productTypes: ProductType[], t: Translate) => {
    const generics = []
    const diff = []

    for (const pt of productTypes) {
      if (pt.name.includes('(d)')) {
        diff.push({
          ...pt,
          group: t('pages.products.broadcaster_other'),
        })
      } else {
        generics.push({ ...pt, group: t('_generics.generic') })
      }
    }

    return [
      ...generics.sort((a, b) => a.name.localeCompare(b.name)),
      ...diff.sort((a, b) => a.name.localeCompare(b.name)),
    ]
  },
}
